import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { ActionButton } from '@/components/ActionButton';
import { LogDetailsCard } from '@/features/logs/LogCards';

export const Route = createFileRoute('/a/logs/$eventId')({
  staticData: {
    breadcrumbs: [{ label: 'Logs', url: '/a/logs' }, { label: 'Log' }],
  },
  component: AdminLogDetailsPage,
});

function AdminLogDetailsPage() {
  const { eventId } = Route.useParams();

  return (
    <div className="space-y-4">
      <ActionButton asChild size="sm" variant="outline">
        <Link to="/a/logs">
          <ArrowLeft className="h-4 w-4" />
          Back to logs
        </Link>
      </ActionButton>
      <LogDetailsCard restaurantId={null} eventId={eventId} />
    </div>
  );
}
